var SectionMetadata = /** @class */ (function () {
    function SectionMetadata(headlineRowIndex, endRowIndex, section, isFirstSection) {
        this.headlineRowIndex = headlineRowIndex;
        this.endRowIndex = endRowIndex;
        this.section = section;
        this.isFirstSection = isFirstSection;
    }
    Object.defineProperty(SectionMetadata.prototype, "startRowIndex", {
        get: function () {
            if (this.isFirstSection) {
                return this.headlineRowIndex;
            }
            return this.headlineRowIndex + 1;
        },
        enumerable: false,
        configurable: true
    });
    SectionMetadata.prototype.isActiveSection = function (rowIndex) {
        return this.headlineRowIndex <= rowIndex && this.endRowIndex >= rowIndex;
    };
    SectionMetadata.prototype.getItemIndex = function (rowIndex, columnIndex, columnCount) {
        var normalizedRowIndex = rowIndex - this.startRowIndex;
        var itemIndex = columnCount * normalizedRowIndex + columnIndex;
        return itemIndex;
    };
    SectionMetadata.prototype.resolveRowHeight = function (rowIndex, columnWidth, themeAccessor) {
        if (typeof this.section.rowHeight === 'function') {
            var normalizedRowIndex = rowIndex - this.headlineRowIndex;
            return this.section.rowHeight(normalizedRowIndex, columnWidth);
        }
        return themeAccessor.resolveNumericFactor(this.section.rowHeight) || 0;
    };
    return SectionMetadata;
}());
export default SectionMetadata;
//# sourceMappingURL=SectionMetadata.js.map